export default "__VITE_ASSET__9cyNYm_Q__"